import { StepItemProps } from "@bsm/component";
import ISO6391 from "iso-639-1";
import { useMemo } from "react";
import countries from "i18n-iso-countries";

export const useInformationStep = (): StepItemProps => {
    const nationalities = useMemo(() => {
        const nationalities = Object.values(
            countries.getNames("en", { select: "official" })
        );
        const alpha2Codes = Object.keys(countries.getAlpha2Codes());

        return nationalities.map((ln) => {
            return {
                label: ln,
                value: ln,
                startIcon: (
                    <img
                        src={`/assets/flags/${alpha2Codes[nationalities.indexOf(ln)]}.png`}
                        alt=""
                    />
                ),
            };
        });
    }, []);

    return {
        data: {
            title: "General Information",
            forms: [
                { type: "hidden", name: "id" },
                {
                    type: "profile-picture",
                    name: "profilePicture",
                    accept: { "image/*": [".png", ".jpg", ".jpeg", ".svg"] },
                    label: "Photos",
                    required: true,
                },
                {
                    type: "input",
                    name: "lastName",
                    label: "Family Name",
                    required: true,
                },
                {
                    type: "input",
                    name: "firstName",
                    label: "First Name",
                    required: true,
                },
                {
                    type: "input",
                    name: "preferredName",
                    label: "Preferred Name",
                    required: true,
                },
                {
                    type: "date",
                    name: "dateBirth",
                    label: "Date Of Birth",
                    required: true,
                },
                {
                    type: "checkbox",
                    name: "sexe",
                    label: "Gender",
                    required: true,
                    options: [
                        {
                            label: "Male",
                            value: "MALE",
                        },
                        {
                            label: "Female",
                            value: "FEMALE",
                        },
                    ],
                },
                {
                    type: "select",
                    name: "nationality",
                    label: "Nationality",
                    options: nationalities,
                    required: true,
                },
                {
                    type: "select",
                    name: "language",
                    label: "Language",
                    options: ISO6391.getAllNames().map((language) => ({
                        label: language,
                        value: language,
                    })),
                    required: true,
                },
                {
                    type: "input",
                    name: "email",
                    label: "Email",
                },
                // {
                //     type: "input",
                //     name: "pearsonLogin",
                //     label: "Pearson Login",
                // },
                // {
                //     type: "input",
                //     name: "epicLogin",
                //     label: "Epic Login",
                // },
            ],
            next: {
                label: "Save",
            },
            hideBack: true,
            graphQL: {
                entity: "user",
            },
        },
    };
};
